module.exports = __webpack_public_path__ + "static/media/10-3.8f060a57.mp3";